import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorCtaBannerData = (data, key) => {

  const keyItem = key ? key : 'ipcb'

  const short = (data[`${keyItem}ImageStyle`] && data[`${keyItem}ImageStyle`].toLowerCase() === 'short') ? true : false;

  var imgData;

  if (data[`${keyItem}BannerImage`]) {
    imgData = data[`${keyItem}BannerImage`];
  } else if (data[`${keyItem}Image`]) {
    imgData = data[`${keyItem}Image`];
  }

  const img = imgData ? refactorRespImg(imgData, [{
    size: 'default',
    key: 'image_size_840x280'
  },{
    size: 'md',
    key: 'image_size_1280x430',
  },{
    size: 'lg',
    key: 'image_size_1600x534'
  }]) : null;

  const ctasArr = get(data, `${keyItem}CtasRep`, null)
  const ctas = ctasArr ? get(data, `${keyItem}CtasRep`, []).map(item => {
    return {
      color: get(item, `${keyItem}CtaColour`, null),
      href: get(item, `${keyItem}CtaLink.url`, null),
      title: get(item, `${keyItem}CtaLink.title`, null),
      target: get(item, `${keyItem}CtaLink.target`, null),
    }
  }) : [];

  return {
    mainHeading: data[`${keyItem}HeadingText`] || null,
    headingSize: "extraLarge",
    subHeading1: data[`${keyItem}PreheadingText`] || null,
    subHeading2: data[`${keyItem}SubheadingText`] || null,
    bgVideoMobile: {
      src: get(data, `${keyItem}VideoMobile.guid`, null),
      mimeType: get(data, `${keyItem}VideoMobile.mimeType`, null)
    },
    bgVideoDesktop: {
      src: get(data, `${keyItem}VideoDesktop.guid`, null),
      mimeType: get(data, `${keyItem}VideoDesktop.mimeType`, null)
    },
    bgImage: img,
    ctas
  }
}

export default refactorCtaBannerData